var Request = require('../helper/request');
var queryString = require('query-string');

function Statistic(app, companyId){
	var self = this;
	self.app = app;
	self.companyId = companyId;
	self.request = new Request(app);

	self.routes = {
		index: {
			url: "/company/"+self.companyId+"/statistic",
			method: "GET"
		}
	};
}

/*
* Fields = [branch_id, type, value]
* ** Type = ["month", "day"]
*/
Statistic.prototype.index = function(fields = false){
	var self = this;
	var uri = self.routes.index.url;

	if(fields){
		uri = uri + "?" + queryString.stringify(fields);
	}

	return self.request.get(uri)
}

module.exports = Statistic;